/**
 * user 用户中心api
 */
import { Method } from '../core';
import { API, SOURCE } from '../config';

const api = API;

export default {
  // 注销账户 /rest/v1/account/cance
  cancelAccount: {
    url: `${api}/rest/v1/account/cancel`,
    method: Method.POST,
    body: {
      // 建议
      suggestion: {
        $type: String
      },
      // 注销原因
      reason: {
        $type: [String, Array]
      },
      // 是否在web注销 0-web 1-h5 default web
      type: {
        $type: [String, Number],
        $default: 0
      },
      // 账号Uid
      accountUid: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 同意协议 /rest/v1/account/protocol/accept
  acceptProtocol: {
    url: `${api}/rest/v1/account/protocol/accept`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      // 印章授权: GRANT_SEAL 注销账号: CANCEL_ACCOUNT
      protocolType: {
        $type: String
      },
      accountUid: {
        $type: String
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/user.js